import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InlineForm from 'components/forms/InlineForm';
import { FieldType } from 'types/FieldTypes';
import { FormButtonType } from 'types/ButtonTypes';
import { saveData } from 'services/api/saveData';
import { v4 as uuidv4 } from 'uuid';

const ForgotPasswordForm: React.FC = () => {
    const { t } = useTranslation();
    const viewKey = useMemo(() => uuidv4(), []);

    // Store whether the reset email request is sent
    const [sent, setSent] = useState<boolean>(false);

    const formHeader = 'account.forgot_password_header_label'
    const formDescription = 'account.forgot_password_header_description'

    const fields: FieldType[] = [
        {
            type: 'email',
            name: 'email',
            placeholder: 'account.your_email_placeholder',
        },
    ];

    const buttons: FormButtonType[] = [
        {
            label: 'account.forgot_password_button_label',
            position: 'fullwidth',
            hierarchy: 'primary',
            onClick: 'handleSubmit',
            size: 'large',
            showLoader: true,
        },
    ];

    // Send the reset request and show the confirmation instead of the form
    const handleForgotPassword = async (data: Record<string, any>) => {
        await saveData({ apiObject: 'forgotpassword', data });
        setSent(true);
    };

    // Show the confirmation after the reset email request is sent
    if (sent) {
        return (
            <div className='forgot-password-confirmation'>
                <h4>{t('account.forgot_password_sent_header')}</h4>
                <p>{t('account.forgot_password_sent_description')}</p>
            </div>
        );
    }

    return (
        <InlineForm
            viewKey={viewKey}
            customApiFunction={handleForgotPassword}
            apiObject='forgotpassword'
            formHeader={formHeader}
            formDescription={formDescription}
            fields={fields}
            buttons={buttons}
        />
    );
};

export default ForgotPasswordForm;
